import { render, staticRenderFns } from "./ServeFee.vue?vue&type=template&id=7b8ff0a3"
import script from "./ServeFee.vue?vue&type=script&lang=js"
export * from "./ServeFee.vue?vue&type=script&lang=js"
import style0 from "./ServeFee.vue?vue&type=style&index=0&id=7b8ff0a3&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b8ff0a3')) {
      api.createRecord('7b8ff0a3', component.options)
    } else {
      api.reload('7b8ff0a3', component.options)
    }
    module.hot.accept("./ServeFee.vue?vue&type=template&id=7b8ff0a3", function () {
      api.rerender('7b8ff0a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/clinic/ServeFee.vue"
export default component.exports